import { useMutation } from "@tanstack/react-query";
import { queryService } from "@/api/services/query-service";
import { useCheckoutStore } from "../store/checkout-store";
import { useToast } from "@/features/toast";
import { useTranslation } from "react-i18next";
import type { SubmitApprovalItem } from "@/api/models/api-types";

export const useCheckoutApprovals = () => {
  const { t } = useTranslation();
  const { error } = useToast();

  const {
    isApprovalModalOpen,
    approvalMerchants,
    pendingCheckoutPayload,
    closeApprovalModal,
  } = useCheckoutStore();

  // GET checkout-approvals (lazy — called manually inside completeOrder)
  const fetchApprovals = async () => {
    return queryService.getCheckoutApprovals();
  };

  // POST checkout-approvals mutation
  const submitApprovalsMutation = useMutation({
    mutationFn: (approvals: SubmitApprovalItem[]) =>
      queryService.submitCheckoutApprovals({ approvals }),
    onError: (apiError: any) => {
      console.error("❌ Submit approvals error:", apiError);
      error(
        apiError?.response?.data?.message ||
          apiError?.message ||
          t("checkout.merchantApproval.submitError"),
      );
    },
  });

  return {
    // State from store
    isApprovalModalOpen,
    approvalMerchants,
    pendingCheckoutPayload,

    // Actions
    closeApprovalModal,
    fetchApprovals,

    // Mutations
    submitApprovals: submitApprovalsMutation.mutateAsync,
    isSubmitting: submitApprovalsMutation.isPending,
  };
};
